// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

export const groupsApi = createApi({
  reducerPath: "groupsApi",
  baseQuery: encryptedBaseQueryWithReauth(),

  tagTypes: ["getGroupList", "getMembers", "getGroupDoubts", "getGroupById",'getBlockUsers'],
  endpoints: (builder) => ({
    getGroupList: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getGroupList"],
    }),

    getGroupAnalytics: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getGroupAnalytics"],
    }),

    getGroupByEntityType: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
    }),

    getGroupById: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getGroupById"],
    }),
    getGroupDoubts: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getGroupDoubts"],
    }),

    getMembers: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getMembers"],
    }),
    getBlockUsers: builder.query({
      query: (endpoint) => `${endpoint}`,
      providesTags: ["getBlockUsers"],
    }),

    linkGroup: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "POST",
        body: updatedData,
      }),
      // invalidatesTags: ["getGroupList"],
    }),

    updateField: builder.mutation({
      query: ({ endpoint, updatedData }) => ({
        url: endpoint,
        method: "PATCH",
        body: updatedData,
        headers: {
          "content-type": "application/json",
        },
      }),
      // invalidatesTags: ["getGroupList"],
    }),

    createGroup: builder.mutation({
      query: ({ endpoint, newGroup }) => ({
        url: endpoint,
        method: "POST",
        body: newGroup,
      }),
      invalidatesTags: ["getGroupList"],
    }),

    handleActions: builder.mutation({
      query: ({ endpoint, data }) => ({
        url: endpoint,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ({ success }) => {
        if (success) {
          return ["getGroupById"];
        }
      },
    }),
     getAnalystics: builder.query({
      query: (endpoint) => `${endpoint}`,
    }),
  }),
});

export const {
  useGetGroupListQuery,
  useGetBlockUsersQuery,
  useLazyGetGroupListQuery,
  useGetGroupByIdQuery,
  useGetGroupByEntityTypeMutation,
  useCreateGroupMutation,
  useUpdateFieldMutation,
  useGetMembersQuery,
  useLazyGetMembersQuery,
  useGetGroupDoubtsQuery,
  useLinkGroupMutation,
  useHandleActionsMutation,
  useGetGroupAnalyticsQuery,
  useGetAnalysticsQuery,
} = groupsApi;
